import React, { Component } from 'react';
import FMParameters from './FMParameters.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import LFOComponent from 'components/lfo/LFOComponent.js';
import FMCarrierOscillatorComponent from './FMCarrierOscillatorComponent.js';
import FMModulatorOscillatorComponent from './FMModulatorOscillatorComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import OscillatorsComponent from './OscillatorsComponent.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'
import FMGenetix from './FMGenetix.js';
import EnvelopesComponent from './EnvelopesComponent.js';
import SynthMods from './SynthMods.js';
import '../../Instruments.scss';
import {AMP, FILTER, FILTER_2, PITCH, MODULATION} from 'constants/envelope-types.js';

class FMSynthComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMods: false,
            showGenetix: false,
        };

        this.onClickMods = this.onClickMods.bind(this);
        this.onClickGenetix = this.onClickGenetix.bind(this);
    }

    onClickMods() {
        this.setState({showMods: !this.state.showMods});
    }

    onClickGenetix() {
        this.setState({showGenetix: !this.state.showGenetix});
    }

    render() {
        let instrument = this.props.instrument;
        return (
            <div className="instrument fm-synth">
              <ConditionedComponent condition={!this.state.showMods && !this.state.showGenetix}>
                <div className="clear-fix"/>
                <FMParameters sequencerEngine={this.props.sequencerEngine} instrument={instrument}/>
                <div className="instrument-section">
                  <div className="instrument-subsection">
                    <div className="instrument-subsection-name">
                      Filter
                    </div>
                    <div className="clear-fix"/>
                    <EffectParameterSlider
                      automation={this.props.automation}
                      name={'Cutoff'}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      parameter={instrument.filterCutoffParameter}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={10000}
                      step={1}
                      />
                    <EffectParameterSlider
                      automation={this.props.automation}
                      name={'Q'}
                      sequencerEngine={this.props.sequencerEngine}
                      parameter={instrument.filterQParameter}
                      lfoEnabled={true}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={9}
                      step={1}
                      />
                    <EffectParameterSlider
                      automation={this.props.automation}
                      name={'Noise Level'}
                      sequencerEngine={this.props.sequencerEngine}
                      parameter={instrument.noiseVolumeParameter}
                      lfoEnabled={true}
                      onParameterChanged={() => []}
                      unit='db'
                      isParameter={true}
                      min={-100}
                      max={0}
                      step={0.1}
                      />
                  </div>
                  <div className="instrument-subsection">
                    <FMCarrierOscillatorComponent
                      automation={this.props.automation}
                      oscillator={instrument.carrierOscillator}
                      sequencerEngine={this.props.sequencerEngine}
                      instrument={instrument}/>
                  </div>
                </div>
                <div className="instrument-section">
                  <div className="instrument-subsection">
                    <EnvelopesComponent
                      automation={this.props.automation}
                      envelopeOptions={ENVELOPE_OPTIONS}
                      sequencerEngine={this.props.sequencerEngine}
                      instrument={instrument}/>
                  </div>
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.showGenetix}>
                <div className="clear-fix"/>
                <FMGenetix onClickBack={() => this.onClickGenetix()} track={this.props.track} instrument={instrument}/>
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.showMods}>
                <div className="clear-fix"/>
                <SynthMods instrument={instrument}/>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.showGenetix}>
                <div
                  onClick={this.onClickMods}
                  className="mods-button common-button pink-button small-button">
                  {this.state.showMods ? 'BACK' : 'MODS'}
                </div>
                <div
                  onClick={this.onClickGenetix}
                  className="mods-button common-button pink-button small-button">
                  GENETIX
                </div>
              </ConditionedComponent>
            </div>);
    }
}

const ENVELOPE_OPTIONS = [
    {value: AMP, label: 'Amp'},
    {value: FILTER, label: 'Filter'},
    {value: FILTER_2, label: 'Filter 2'},
    {value: MODULATION, label: 'Modulation'},
];

export default FMSynthComponent;
